// import { editorUpdating, hideAlert, showAlert } from 'core';
/* import {
  DOCUMENT_WAS_ADDED_BY_SOMEONE,
  DOCUMENT_WAS_DELETED,
  DOCUMENT_WAS_MODIFIED,
  STATUS,
  WORKSPACE_WAS_DELETED,
  WORKSPACE_WAS_MODIFIED,
} from 'core/literals'; */
// import getPathId from 'core/utils/get-path-id';
// import getReduxState from 'core/utils/get-redux-state';

// const getRevisionNumber = (revision: any): number => Number(revision.match(/(\d+)-.*?/)[1]);
// const isAddedDocument = (revision: string): boolean => getRevisionNumber(revision) === 1;
/*
const onChangeDB =
  (dispatch: any) =>
  ({ doc }: any) => {
    const { _deleted: isDeleted, _id: documentId, _rev: rev, root: documentRoot, type } = doc;
    const {
      editor: { created: isCreated, updating },
      pouchdb: { order, root },
    } = getReduxState();

    const isCurrentWorkspace = root === documentRoot;
    const isTree = order?.status !== STATUS.IDLE;

    // "isCurrentWorkspace" - if the variable isCurrentWorkspace false we do not show any messages. because we use another project.
    // "updating" - if the variable updating is null we show the message to the user that opened the document but has not edited yet.
    // "isTree" - checks if it is a tree.
    // "isCreated" - if the document/entity was created.

    if (!isCurrentWorkspace || updating || isTree || !!isCreated) {
      if (updating) {
        dispatch(editorUpdating(null));
      }

      return;
    }

    const currentId = getPathId({ pathname: window.location.hash.toString().slice(1) });
    const currentDocument = documentId === currentId;

    dispatch(hideAlert(currentId));

    const alertOptions = {
      id: currentId,
      variant: 'success',
      timeout: 10,
    };

    if (isDeleted) {
      dispatch(
        showAlert(currentDocument ? DOCUMENT_WAS_DELETED : WORKSPACE_WAS_DELETED, alertOptions),
      );
    } else if (isAddedDocument(rev)) {
      dispatch(showAlert(DOCUMENT_WAS_ADDED_BY_SOMEONE.replace('{type}', type), alertOptions));
    } else {
      dispatch(
        showAlert(currentDocument ? DOCUMENT_WAS_MODIFIED : WORKSPACE_WAS_MODIFIED, alertOptions),
      );
    }
  };
  */

// todo it should be checked
export default ({}: any) => {
  // console.log('dispatch', dispatch);
  /*
  useEffect(() => {
    if (!instance) {
      return;
    }

    instance.getInstance().on('change', onChangeDB(dispatch));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance]);
  */
};
